import { GC_GET_ASSET_LIST, GC_GET_MEDIA_LIBRARY_LIST } from '@/graphql/assets'
import apollo from '@/apolloClient'

export default {
    namespaced: true,
    state: {
        list: [],
        media_list_by_scenario: [],
    },
    mutations: {
        SET_ASSET_LIST(state, assets){
            // Generate asset urls
            assets.map(asset => {
                if (asset.path){
                    asset.url = process.env.VUE_APP_AWS_S3_URL + '/' + asset.path
                }
            })

            state.list = (assets || [])
        },
        SET_MEDIA_LIST_BY_SCENARIO(state, scenarios){
            // Generate asset urls
            state.media_list_by_scenario = (scenarios || [])
        }
    },
    actions: {
        async getList({ commit }){
            const response = await apollo.query({query: GC_GET_ASSET_LIST})
            
            commit('SET_ASSET_LIST', response.data.media)
        },
        async getMediaListByScenario({ commit }){
            // Get pdf and media nodes from main scenario present in the main locations
            const response = await apollo.query({
                query: GC_GET_MEDIA_LIBRARY_LIST,
                variables: { 
                    location_slugs: [ 'expert_house', 'oph_ca', 'oph_dg', 'oph_dgl', 'oph_caleol', 'oph_daf', 'construction_site', 'town_hall' ],
                    type_slugs: [ 'pdf', 'media' ]
                }
            })

            // Create array of scenario with their media/pdf nodes
            if (response.data.location && response.data.location.length > 0) {
                const scenarios = response.data.location.reduce((scenarios, location) => {
                    // Get main scenarios from this location
                    if (location.scenarioLocations && location.scenarioLocations.length > 0) {
                        for (var i = 0; i < location.scenarioLocations.length; i++) {
                            // Check if with have some media/pdf nodes for this scenario
                            const scenario = location.scenarioLocations[i].scenario

                            if (scenario.nodes && scenario.nodes.length > 0) {
                                scenarios.push(scenario)
                            }
                        }
                    }

                    return scenarios
                }, [])

                commit('SET_MEDIA_LIST_BY_SCENARIO', scenarios)
            } else {
                commit('SET_MEDIA_LIST_BY_SCENARIO', [])
            }
        }
    }
}